module.exports = __webpack_public_path__ + "img/beaker-blue-dark.f1e4ab4b.png";